function mockHelper(type) {
    return new Promise((resolve, reject) => {
        let data = null;
        try {
            setTimeout(function() {
                data = assortedFile(type);
                resolve(data);
            }, 500)
            
        } catch(e) {
            reject({
                isError: true,
            })
            return;
        }
        
    })
}
function assortedFile(type) {
    switch(type) {
        case 'home_page':
            return require('./mockData/home_page.json');
        case 'product_detail':
            return require('./mockData/product_detail.json')
        case 'street_snap_detail':
            return require('./mockData/street_snap_detail.json')
        case 'personal_page1':
            return require('./mockData/personal_page1.json')
        case 'personal_page2':
            return require('./mockData/personal_page2.json')
        case 'product_more':
            return require('./mockData/product_more.json')
        default:
            return {
                nothing: null
            }
    }
}
export default mockHelper;


// WEBPACK FOOTER //
// ./src/common/mockHelper.js